import { render, staticRenderFns } from "./BiBoard.vue?vue&type=template&id=557f661a&scoped=true"
import script from "./BiBoard.vue?vue&type=script&lang=js"
export * from "./BiBoard.vue?vue&type=script&lang=js"
import style0 from "./BiBoard.vue?vue&type=style&index=0&id=557f661a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f661a",
  null
  
)

export default component.exports